import {IMessageData, IRouteDefinitionParams} from "../index";
import * as ko from "knockout";
import {Toggle} from "../util/Toggle";
import {KOSubscriptionTracker} from "../util/KOSubscriptionTracker";
import {TabManager} from "./tab-list/TabManager";
import {nsRoute} from "../util/route";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import {Tab} from "./tab-list/Tab";
import {ERROR_MESSAGE, REQUEST_MESSAGE} from "../constants/Language";

export default class DetailsPage<TData = unknown> extends ParsedRouteDataDecorator {
    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    isReady: KnockoutObservable<boolean> = ko.observable(false);

    data: KnockoutObservable<TData | null> = ko.observable(null);

    protected kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private readonly tab?: Tab;
    private readonly tabManager?: TabManager;

    constructor(params: IRouteDefinitionParams, autoRequest: boolean = true) {
        super(params);
        if (autoRequest) {
            this.request();
        }
    }

    protected request(): Promise<any> {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        return this.__requestRouteData!
            .request()
            .then((data: any[]) => this.onSuccess(data as [TData]))
            .catch(this.onError.bind(this));
    }

    protected onSuccess(data: [TData]) {
        this.messageData(null);
        this.data(data[0]);
        this.isReady(true);
    }

    protected onError(message: string) {
        this.messageData({
            message: ERROR_MESSAGE + `<div>Årsak: ${message}</div>`,
            type: "danger"
        })
    }

    override dispose() {
        super.dispose();
        this.kosub.unsuscribeAll();
    }

}
